import { render, staticRenderFns } from "./scroll-card.vue?vue&type=template&id=7662c3d6&scoped=true"
import script from "./scroll-card.vue?vue&type=script&lang=js"
export * from "./scroll-card.vue?vue&type=script&lang=js"
import style0 from "./scroll-card.vue?vue&type=style&index=0&id=7662c3d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7662c3d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImage: require('/builds/wj/fe/wenjuan-homesite/components/common/image.vue').default})
